import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { setAdministeredByAnotherUnitOptions } from '../store/options.actions'
import { OptionsService } from '../services/options.service'

export function* getAdministeredByAnotherUnitOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getAdministeredByAnotherUnitOptions])
    const { entity } = response
    if (entity) yield put(setAdministeredByAnotherUnitOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getAdministeredByAnotherUnit() error: ${e}`))
  }
}

export function* getAdministeredByAnotherUnitOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getAdministeredByAnotherUnitOptions)
}
